<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl">🎯</span>
        <span>适合您的职业方向</span>
      </h2>
      <p class="text-gray-600 text-lg">基于您的Holland Code推荐的职业领域</p>
    </div>

    <!-- 主要推荐 -->
    <div 
      class="p-6 rounded-xl mb-6 border"
      :style="{ 
        background: `linear-gradient(135deg, ${primaryType.bgColor}, #ffffff)`,
        borderColor: primaryType.color + '20'
      }"
    >
      <h4 class="text-lg font-semibold mb-4" :style="{ color: primaryType.color }">
        {{ primaryType.emoji }} {{ primaryType.name }} 主要推荐职业
      </h4>
      <p class="text-base leading-relaxed text-gray-800">
        {{ primaryType.suitable }}
      </p>
    </div>

    <div class="border-t pt-4 mb-4"></div>

    <!-- 次要和第三类型推荐（Grid布局）-->
    <div class="grid md:grid-cols-2 gap-6">
      <!-- 次要类型 -->
      <div 
        class="p-5 rounded-xl border"
        :style="{ 
          backgroundColor: secondaryType.color + '10',
          borderColor: secondaryType.color + '20'
        }"
      >
        <h4 class="text-base font-semibold mb-3" :style="{ color: secondaryType.color }">
          {{ secondaryType.emoji }} {{ secondaryType.name }} 辅助推荐
        </h4>
        <p class="text-sm text-gray-700">{{ secondaryType.suitable }}</p>
      </div>

      <!-- 第三类型 -->
      <div 
        class="p-5 rounded-xl border"
        :style="{ 
          backgroundColor: tertiaryType.color + '10',
          borderColor: tertiaryType.color + '20'
        }"
      >
        <h4 class="text-base font-semibold mb-3" :style="{ color: tertiaryType.color }">
          {{ tertiaryType.emoji }} {{ tertiaryType.name }} 延伸推荐
        </h4>
        <p class="text-sm text-gray-700">{{ tertiaryType.suitable }}</p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 适合的职业方向组件
 * 展示基于三个Holland类型的职业推荐
 */
export default {
  name: 'CareerDirections',
  props: {
    primaryType: {
      type: Object,
      required: true
    },
    secondaryType: {
      type: Object,
      required: true
    },
    tertiaryType: {
      type: Object,
      required: true
    }
  }
}
</script>

